import React, { useState, useEffect } from "react";

import { GetScheduleMNG } from "../api/schedule_mng";
import { Me } from "../api/users";
import { CreateMNGShift, DeleteShift } from "../api/mng_shift";
import { OpentypeShiftGet } from "../api/type_shift";
import { GetApprove, Approve } from "../api/approved_mng";

import { DirectorLevel, TYLevel, HRLevel } from "../constants";
import { GetReportMNG } from "../api/report";

const ScheduleMNG = ({ token }) => {
  const [user, setUser] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [tableSchedule, setTableSchedule] = useState();
  const [endRenderScheduleTable, setEndRenderScheduleTable] = useState();
  const [addForm, setAddForm] = useState({
    name: "",
    start: 0,
    end: 0,
    userId: 0,
    date: "",
    index: 0,
    typeShiftId: 1,
  });
  const [deleteForm, setDeleteForm] = useState({ MNGShiftId: 0, userId: 0 });
  const [infoMessage, setInfoMessage] = useState("");
  const [openTypeShiftList, setOpenTypeShiftList] = useState([]);
  const [tableHours, setTableHours] = useState();
  const [haveShiftOrNo, setHaveShiftOrNo] = useState(true);

  const [dataApprove, setDataApprove] = useState();
  const [tableApprove, setTableApprove] = useState();
  const [userApprove, setUserApprove] = useState({
    status_id: "1",
    comment: "",
  });
  const [arrayDate, setArrayDate] = useState(
    getFormattedMonthDates(new Date().toISOString().split("T")[0]),
  );
  const [accessLevelUser, setAccessLevelUser] = useState();

  const NameShift = ["МС", "МР", "Инвен", "Пипл", "Админ", "Командировка"];

  const [startDateDownload, setStartDateDownload] = useState();
  const [endDateDownload, setEndDateDownload] = useState();
  const [approveMessage, setApproveMessage] = useState("");
  const [normaHours, setNormaHours] = useState(165);

  const [activeTab, setActiveTab] = useState("schedule");
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [scheduleLoaded, setScheduleLoaded] = useState(false);
  const [monthPickerDate, setMonthPickerDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const loadTypeShift = async () => {
    try {
      const response = await Me(token);
      console.log(response);
      setUser(response);

      const statusShits = await OpentypeShiftGet(token);
      setOpenTypeShiftList(statusShits);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadTypeShift();
  }, [token]);

  useEffect(() => {
    if (token && user) {
      getScheduleMNG();
    }
  }, [token, user]);

  useEffect(() => {
    if (tableSchedule && scheduleLoaded) {
      renderScheduleTable(tableSchedule);
      renderHoursTable(tableSchedule);
    }
  }, [openTypeShiftList]);

  function getMngShiftTypeName(shift) {
    if (shift?.type_shift_name) {
      return shift.type_shift_name;
    }
    for (let tp of openTypeShiftList) {
      if (tp.id == shift.type_shift_id) {
        return tp.name;
      }
    }
    return "";
  }

  function getMngShiftCellClass(shift) {
    if (!shift) return "shift-cell--mng-status";
    const typeId = Number(shift.type_shift_id);
    if (typeId === 1) return getMngShiftNameCellClass(shift);
    return "shift-cell--mng-status";
  }

  function getMngShiftNameCellClass(shift) {
    const classByName = {
      Админ: "shift-cell--mng-admin",
      Пипл: "shift-cell--mng-pipl",
      Инвен: "shift-cell--mng-inven",
      МС: "shift-cell--regular",
      МР: "shift-cell--mng-mr",
    };
    return classByName[shift?.name] || "shift-cell--mng-shift";
  }

  function calculateMngShiftHours(start, end) {
    const startNum = Number(start);
    const endNum = Number(end);
    if (Number.isNaN(startNum) || Number.isNaN(endNum)) {
      return NaN;
    }
    if (startNum > endNum) {
      return 24 - startNum + endNum;
    }
    return endNum - startNum;
  }

  function validateNameShiftDuration() {
    if (!NameShift.includes(addForm.name) || addForm.typeShiftId !== 1) {
      return null;
    }
    const hours = calculateMngShiftHours(addForm.start, addForm.end);
    if (Number.isNaN(hours) || hours < 1) {
      return "Для смены из списка (МС, МР, Инвен и др.) длительность должна быть не менее 1 часа";
    }
    return null;
  }

  function switchTab(tab) {
    setActiveTab(tab);
    if (tab === "schedule" && !scheduleLoaded) getScheduleMNG();
    if (tab === "approve" && !dataApprove) loadAppored();
  }

  function selectDate(event) {
    const date = event.target.value;
    setMonthPickerDate(date);
    const selectDateInput = new Date(event.target.value);
    if (selectDateInput.getMonth() == 1) {
      setNormaHours(148);
    } else {
      setNormaHours(165);
    }
    setArrayDate(getFormattedMonthDates(selectDateInput));
    setSelectedDate(date);
    setScheduleLoaded(false);
    setEndRenderScheduleTable(null);
    setTableHours(null);
    setDataApprove(undefined);
    setTableApprove(undefined);

    if (activeTab === "schedule") {
      getScheduleMNG(date);
    } else if (activeTab === "approve") {
      const monthDates = getFormattedMonthDates(selectDateInput);
      loadAppored(monthDates[0], monthDates.at(-1));
    }
  }

  async function getScheduleMNG(overrideDate) {
    const date = overrideDate ?? selectedDate;
    if (!user) return;
    if (!overrideDate && (scheduleLoaded || isLoadingSchedule)) return;

    setIsLoadingSchedule(true);
    try {
      const data = await GetScheduleMNG(token, date, user.restaurant_id);
      setTableSchedule(data);
      renderScheduleTable(data, date);
      renderHoursTable(data);
      setScheduleLoaded(true);
      if (overrideDate) {
        setSelectedDate(date);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSchedule(false);
    }
  }

  async function haveShift(shift, dayIndex) {
    setHaveShiftOrNo(true);
    setDeleteForm({
      MNGShiftId: shift.id,
      userId: shift.user_id,
      index: dayIndex,
      shift: shift,
    });
    setInfoMessage("");
  }

  function notHaveShift(employee, index, date) {
    setHaveShiftOrNo(false);
    setAddForm({
      ...addForm,
      userId: employee.user_id,
      date,
      index: index,
    });
    setInfoMessage("");
  }

  function renderScheduleTable(data, dateOverride) {
    const selectedDateDate = new Date(dateOverride ?? selectedDate);
    const year = selectedDateDate.getFullYear();
    const month = selectedDateDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const weekDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

    const firstRow = [
      <th key="position" rowSpan={2} className="schedule-mng-sticky-col text-center">
        Должность
      </th>,
      <th
        key="name"
        rowSpan={2}
        className="schedule-mng-sticky-col text-center"
        style={{ left: "80px" }}
      >
        Фамилия Имя
      </th>,
    ];
    const secondRow = [];

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      const dayOfWeek = currentDate.getDay();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

      firstRow.push(
        <th
          key={`day-${day}`}
          className={`text-center ${isWeekend ? "schedule-mng-day-header--weekend" : ""}`}
        >
          {day}
        </th>,
      );

      secondRow.push(
        <th
          key={`weekday-${day}`}
          className={`text-center ${isWeekend ? "schedule-mng-weekday--weekend" : ""}`}
          style={{ fontSize: "12px" }}
        >
          {weekDays[dayOfWeek]}
        </th>,
      );
    }

    const renderShift = (shift, dayIndex, employee) => {
      const cellDate = formatDate(new Date(year, month, dayIndex + 1));
      if (!shift) {
        return (
          <td
            key={`shift-${employee.user_id}-${dayIndex}`}
            className="shift-cell text-center shift-cell--regular"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            <div
              className="shift-cell-clickable"
              onClick={() => notHaveShift(employee, dayIndex + 1, cellDate)}
            />
          </td>
        );
      }

      if (Number(shift.type_shift_id) !== 1) {
        const typeShiftName = getMngShiftTypeName(shift);
        return (
          <td
            key={`shift-${shift.user_id}-${dayIndex}`}
            className={`shift-cell text-center ${getMngShiftCellClass(shift)}`}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            <div
              className="shift-cell-clickable"
              onClick={() => haveShift(shift, dayIndex + 1)}
            >
              {typeShiftName}
            </div>
          </td>
        );
      }

      return (
        <td
          key={`shift-${shift.user_id}-${dayIndex}`}
          className={`shift-cell text-center ${getMngShiftNameCellClass(shift)}`}
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          <div
            className="shift-cell-clickable"
            onClick={() => haveShift(shift, dayIndex + 1)}
          >
            <div className="shift-mng-cell-name">{shift.name}</div>
            <div>
              {shift.start}-{shift.end}
            </div>
            {shift.hours > 0 && (
              <div className="shift-mng-cell-hours">{shift.hours} ч</div>
            )}
          </div>
        </td>
      );
    };

    const tbody = data.table.map((employee, empIndex) => (
      <tr key={`emp-${employee.user_id}-${empIndex}`}>
        <td className="schedule-mng-sticky-col text-center fw-semibold">
          {employee.post_name}
        </td>
        <td
          className="schedule-mng-sticky-col text-center"
          style={{ left: "80px" }}
        >
          <div className="employee-name">
            {employee.surname} {employee.name}
          </div>
        </td>
        {employee.shifts.map((shift, dayIndex) =>
          renderShift(shift, dayIndex, employee),
        )}
      </tr>
    ));

    setEndRenderScheduleTable(
      <div className="table-responsive schedule-mng-table-wrap">
        <table className="table table-bordered table-hover schedule-chk-table">
          <thead>
            <tr key="row1">{firstRow}</tr>
            <tr key="row2">{secondRow}</tr>
          </thead>
          <tbody>{tbody}</tbody>
        </table>
      </div>,
    );
  }

  async function createShift() {
    const validationError = validateNameShiftDuration();
    if (validationError) {
      setInfoMessage(<div style={{ color: "red" }}>{validationError}</div>);
      return;
    }

    const data = await CreateMNGShift(
      token,
      addForm.userId,
      addForm.date,
      addForm.start,
      addForm.end,
      addForm.name,
      addForm.typeShiftId,
    );
    console.log(data);
    if (data.detail) {
      setInfoMessage(<div style={{ color: "red" }}>{data.detail}</div>);
      return;
    }
    // console.log(tableSchedule)
    setDeleteForm({
      MNGShiftId: data.id,
      userId: data.user_id,
      index: addForm.index,
    });
    const updatedTableSchedule = { ...tableSchedule };

    for (let user of updatedTableSchedule.table) {
      if (user.user_id == addForm.userId) {
        // Создаем копию массива смен
        const updatedShifts = [...user.shifts];
        updatedShifts[addForm.index - 1] = data; // index - 1 т.к. дни с 1, а индексы с 0
        user.shifts = updatedShifts;
      }
    }
    setInfoMessage(<div style={{ color: "green" }}>Готово!</div>);
    setTableSchedule(updatedTableSchedule); // ✅ Устанавливаем обновленный объект
    renderScheduleTable(updatedTableSchedule); // ✅ Перерисовываем таблицу
    renderHoursTable(updatedTableSchedule);
  }

  async function deleteShift() {
    const data = await DeleteShift(token, deleteForm.MNGShiftId);
    if (data.detail) {
      setInfoMessage(<div style={{ color: "red" }}>{data.detail}</div>);
      return;
    }
    const updatedTableSchedule = { ...tableSchedule };
    setAddForm({
      ...addForm,
      userId: data.user_id,
      date: data.date,
      index: deleteForm.index,
    });
    for (let user of updatedTableSchedule.table) {
      if (user.user_id == deleteForm.userId) {
        // Создаем копию массива смен
        const updatedShifts = [...user.shifts];

        // for (let shift in user.shifts){
        //     console.log(shift)
        // }
        // Исправление: используем deleteForm.index без -1
        // поскольку в notHaveShift мы уже сохраняем index с 0
        console.log(deleteForm.index);
        console.log(updatedShifts[deleteForm.index - 1]);
        updatedShifts[deleteForm.index - 1] = null;

        user.shifts = updatedShifts;
      }
    }
    setInfoMessage(<div style={{ color: "green" }}>Удалено!</div>);
    setTableSchedule(updatedTableSchedule);
    renderScheduleTable(updatedTableSchedule);
    renderHoursTable(updatedTableSchedule);
  }

  function renderShiftHours(user) {
    let info = {
      hours: 0,
      shifts: 0,
      weekend: 0,
      sickDays: 0,
      vacations: 0,
      norma: normaHours,
      different: normaHours,
      BKHours: 0,
    };

    for (let shift of user.shifts) {
      if (shift) {
        info.hours += shift.hours;
        if (shift.hours > 1) {
          info.shifts += 1;
        }
        // if (isWeekend(shift.date) )  info.weekend += 1

        if (shift.type_shift_id != 1) {
          switch (shift.type_shift_id) {
            case 4:
              info.weekend += 1;
              break;
            case 5:
              if (!isWeekend(shift.date)) {
                info.different -= 8;
                info.norma -= 8;
              }
              info.sickDays += 1;
              break;
            case 6:
              info.vacations += 1;
              if (!isWeekend(shift.date)) {
                info.different -= 8;
                info.norma -= 8;
              }
              break;
          }
        }
      }
    }
    info.different -= info.hours; //- (info.vacations * 8) - (info.sickDays * 8)

    return (
      <tr key={`hours-${user.user_id}`}>
        <td>
          {user.surname} {user.name}
        </td>
        <td>{info.hours}</td>
        <td>{info.shifts}</td>
        <td>{info.weekend}</td>
        <td>{info.sickDays}</td>
        <td>{info.vacations}</td>
        <td>{info.norma}</td>
        <td>{info.different}</td>
        <td>{info.BKHours}</td>
      </tr>
    );
  }

  function renderHoursTable(data) {
    setTableHours(
      <div className="table-responsive mt-4">
        <h5 className="mb-3">Сводка по часам</h5>
        <table className="table table-bordered table-hover schedule-chk-table">
          <thead>
            <tr>
              <th>Сотрудник</th>
              <th>Часы</th>
              <th>Смен</th>
              <th>Выходных</th>
              <th>Больничных</th>
              <th>Отпусков</th>
              <th>Норма</th>
              <th>Отклонения</th>
              <th>БК часов</th>
            </tr>
          </thead>
          <tbody>{data.table.map((user) => renderShiftHours(user))}</tbody>
        </table>
      </div>,
    );
  }

  function renderModalHaveShift(shift) {
    if (!shift) {
      return;
    }
    let body;
    if (shift.type_shift_id == 1) {
      body = (
        <>
          <dt>Сотрудник</dt>
          <dd>{getEmployeeLabel(shift.user_id)}</dd>
          <dt>Название смены</dt>
          <dd>{shift.name}</dd>
          <dt>Время</dt>
          <dd>
            {shift.start} — {shift.end}
          </dd>
          <dt>Часов</dt>
          <dd>{shift.hours}</dd>
          <dt>Тип</dt>
          <dd>Обычная смена</dd>
          {shift.bk_hours && (
            <>
              <dt>БК часы</dt>
              <dd>{shift.bk_hours}</dd>
            </>
          )}
        </>
      );
    } else if (shift.type_shift_id > 1) {
      let nameTypeShift;
      for (let typeShift of openTypeShiftList) {
        if (typeShift.id == shift.type_shift_id) {
          nameTypeShift = typeShift.name;
        }
      }
      body = (
        <>
          <dt>Сотрудник</dt>
          <dd>{getEmployeeLabel(shift.user_id)}</dd>
          <dt>Статус дня</dt>
          <dd>{nameTypeShift}</dd>
        </>
      );
    }
    return (
      <>
        <div className="schedule-chk-modal-info text-center mb-3">
          <p>
            Дата — <b>{formatMngDisplayDate(shift.date)}</b>
          </p>
        </div>
        <dl className="schedule-mng-modal-details">{body}</dl>
      </>
    );
  }

  const getEmployeeLabel = (userId) => {
    const employee = tableSchedule?.table?.find((e) => e.user_id == userId);
    if (employee) {
      return `${employee.surname} ${employee.name}`;
    }
    return userId;
  };

  const renderCreateShiftContext = () => (
    <div className="schedule-chk-modal-info text-center mb-3">
      <p>
        Сотрудник — <b>{getEmployeeLabel(addForm.userId)}</b>
      </p>
      <p>
        Дата — <b>{formatMngDisplayDate(addForm.date)}</b>
      </p>
    </div>
  );

  const renderAddShiftForm = () => (
    <>
      <div className="mb-3">
        <label className="form-label" htmlFor="mng-shift-name">
          Название смены
        </label>
        <select
          id="mng-shift-name"
          className="form-select"
          value={addForm.name}
          onChange={(e) => setAddForm({ ...addForm, name: e.target.value })}
        >
          <option value="">Не выбрано</option>
          {NameShift.map((shift) => (
            <option key={shift} value={shift}>
              {shift}
            </option>
          ))}
        </select>
        <div className="form-text">МС, МР, Инвен, Пипл и др.</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Время смены</label>
        <div className="input-group">
          <span className="input-group-text">С</span>
          <input
            type="text"
            className="form-control"
            placeholder="Начало"
            aria-label="Начало смены"
            onChange={(e) =>
              setAddForm({ ...addForm, start: Number(e.target.value) })
            }
            value={addForm.start}
          />
          <span className="input-group-text">До</span>
          <input
            type="text"
            className="form-control"
            placeholder="Конец"
            aria-label="Конец смены"
            onChange={(e) =>
              setAddForm({ ...addForm, end: Number(e.target.value) })
            }
            value={addForm.end}
          />
        </div>
        <div className="form-text">Часы в формате 0–24</div>
      </div>
      <div className="mb-3">
        <label className="form-label" htmlFor="mng-shift-type">
          Статус дня
        </label>
        <select
          id="mng-shift-type"
          className="form-select"
          value={addForm.typeShiftId}
          onChange={(e) =>
            setAddForm({ ...addForm, typeShiftId: parseInt(e.target.value) })
          }
        >
          <option value={1}>Не выбрано</option>
          {openTypeShiftList.map((shift) => (
            <option key={shift.id} value={shift.id}>
              {shift.name}
            </option>
          ))}
        </select>
        <div className="form-text">Отпуск, больничный и другие статусы</div>
      </div>
      {infoMessage && (
        <div className="schedule-mng-modal-message text-center mb-2">
          {infoMessage}
        </div>
      )}
    </>
  );

  async function loadAppored(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingApprove) return;
    setIsLoadingApprove(true);
    try {
      const data = await GetApprove(token, from, to);
      setDataApprove(data);
      setTableApprove(renderApprove(data));
      if (accessLevelUser == HRLevel) {
        userApprove["comment"] = data["HR_comment"];
        userApprove["comment"] = data["HR_status"];
      } else if (accessLevelUser == TYLevel) {
        userApprove["comment"] = data["TY_comment"];
        userApprove["status_id"] = data["TY_status"];
      } else if (accessLevelUser == DirectorLevel) {
        userApprove["comment"] = data["director_comment"];
        userApprove["status_id"] = data["director_status"];
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingApprove(false);
    }
  }

  function getApproveBadgeClass(status) {
    if (status == null || status == 1) return "bg-danger";
    if (status == 2) return "bg-warning text-dark";
    if (status == 3) return "bg-success";
    return "bg-secondary";
  }

  function renderApprove(data) {
    const statusTextById = {
      1: "Не согласовано",
      2: "На доработке",
      3: "Согласовано!",
    };
    return (
      <table className="table table-bordered schedule-chk-table">
        <thead>
          <tr className="text-center">
            <th>Директор</th>
            <th>Территориальный управляющий</th>
            <th>HR-менеджер</th>
          </tr>
        </thead>
        <tbody>
          <tr className="text-center">
            <td>
              <span className={`badge ${getApproveBadgeClass(data.director_status)}`}>
                {statusTextById[data.director_status] || "—"}
              </span>
            </td>
            <td>
              <span className={`badge ${getApproveBadgeClass(data.TY_status)}`}>
                {statusTextById[data.TY_status] || "—"}
              </span>
            </td>
            <td>
              <span className={`badge ${getApproveBadgeClass(data.HR_status)}`}>
                {statusTextById[data.HR_status] || "—"}
              </span>
            </td>
          </tr>
          <tr className="text-center">
            <td>{data.director_surname_name}</td>
            <td>{data.TY_surname_name}</td>
            <td>{data.HR_surname_name}</td>
          </tr>
          <tr>
            <td className="text-muted small">{data.director_comment || "—"}</td>
            <td className="text-muted small">{data.TY_comment || "—"}</td>
            <td className="text-muted small">{data.HR_comment || "—"}</td>
          </tr>
          <tr>
            <td
              className="text-center schedule-chk-approve-btn"
              colSpan={3}
              data-bs-toggle="modal"
              data-bs-target="#approvalModal"
            >
              Изменить статус согласования
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  function selectStageApprove(event) {
    console.log(userApprove);
    setUserApprove({ ...userApprove, status_id: event.target.value });
  }

  function onChangeCommentApprove(event) {
    setUserApprove({ ...userApprove, comment: event.target.value });
  }

  async function approveSchedule(event) {
    if (arrayDate.length == 0) {
      setApproveMessage(<p style={{ color: "red" }}>Не выбрана дата!</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    const data = await Approve(
      token,
      arrayDate[0],
      arrayDate.at(-1),
      userApprove["status_id"]?? 1,
      userApprove["comment"]?? "",
    );
    if (data.detail) {
      setApproveMessage(<p style={{ color: "red" }}>{data.detail}</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    setApproveMessage(<p style={{ color: "green" }}>Успешно!</p>);
    setTableApprove(renderApprove(data));
  }

  async function download() {
    const response = await GetReportMNG(
      token,
      startDateDownload,
      endDateDownload,
    );
    console.log(response);

    // Получаем blob из данных ответа axios
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = "food_report.xlsx";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
  }

  const renderLoading = () => (
    <div className="text-center py-5">
      <div
        className="spinner-border"
        style={{ color: "#fd0429" }}
        role="status"
      >
        <span className="visually-hidden">Загрузка...</span>
      </div>
      <p className="text-muted mt-2 mb-0">Загрузка...</p>
    </div>
  );

  const monthLabel = arrayDate[0]
    ? new Date(arrayDate[0]).toLocaleDateString("ru-RU", {
        month: "long",
        year: "numeric",
      })
    : "";

  return (
    <div className="schedule-chk-page schedule-mng-page">
      <div className="schedule-chk-toolbar">
        <div>
          <h1>Расписание МНГ</h1>
          <p className="schedule-chk-hint">
            Выберите любой день месяца — загрузится расписание за весь месяц
          </p>
        </div>
        <div className="schedule-chk-week-picker">
          <input
            type="date"
            className="form-control"
            value={monthPickerDate}
            onChange={selectDate}
          />
          <span className="schedule-chk-week-range">
            {arrayDate[0]} — {arrayDate.at(-1)}
            {monthLabel && ` (${monthLabel})`}
          </span>
        </div>
      </div>

      <ul className="nav nav-tabs schedule-chk-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "schedule" ? "active" : ""}`}
            onClick={() => switchTab("schedule")}
          >
            Расписание
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "approve" ? "active" : ""}`}
            onClick={() => switchTab("approve")}
          >
            Согласование
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "more" ? "active" : ""}`}
            onClick={() => switchTab("more")}
          >
            Прочее
          </button>
        </li>
      </ul>

      <div className="schedule-chk-panel">
        {activeTab === "schedule" && (
          <>
            {isLoadingSchedule ? (
              renderLoading()
            ) : !endRenderScheduleTable ? (
              <div className="schedule-chk-empty">Нет данных за выбранный месяц</div>
            ) : (
              <>
                <div className="schedule-chk-legend">
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-status" />
                    Выходной, отпуск и статусы
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-shift" />
                    Смена
                  </span>
                </div>
                {endRenderScheduleTable}
                <p className="schedule-chk-hint mt-2 mb-0">
                  Пустая ячейка означает по умолчанию выходной (в базе нет смены в
                  этот день).
                </p>
                {tableHours}
              </>
            )}
          </>
        )}

        {activeTab === "approve" && (
          <>
            {isLoadingApprove ? (
              renderLoading()
            ) : !tableApprove ? (
              <div className="schedule-chk-empty">
                Нет данных о согласовании за выбранный месяц
              </div>
            ) : (
              <div className="table-responsive">{tableApprove}</div>
            )}
          </>
        )}

        {activeTab === "more" && (
          <>
            <h5 className="mb-3">Скачивание отчёта</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="mng-download-start" className="form-label">
                  Начало периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="mng-download-start"
                  value={startDateDownload}
                  onChange={(e) => setStartDateDownload(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="mng-download-end" className="form-label">
                  Конец периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="mng-download-end"
                  value={endDateDownload}
                  onChange={(e) => setEndDateDownload(e.target.value)}
                />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <button type="button" className="btn" onClick={download}>
                  Скачать xlsx
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      <div
        className="modal fade modal-schedule-chk-day"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {haveShiftOrNo ? "Информация о смене" : "Новая смена"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              />
            </div>
            <div className="modal-body">
              {haveShiftOrNo ? (
                renderModalHaveShift(deleteForm.shift)
              ) : (
                <>
                  {renderCreateShiftContext()}
                  {renderAddShiftForm()}
                </>
              )}
            </div>
            <div className="modal-footer justify-content-center flex-wrap gap-2">
              {haveShiftOrNo ? (
                <>
                  {infoMessage && (
                    <div className="schedule-mng-modal-message w-100 text-center mb-0">
                      {infoMessage}
                    </div>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Закрыть
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={deleteShift}
                  >
                    Удалить
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Отмена
                  </button>
                  <button type="button" className="btn" onClick={createShift}>
                    Сохранить
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="approvalModal"
        tabIndex="-1"
        aria-labelledby="approvalModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h1 className="modal-title fs-5" id="approvalModelLabel">
                Согласование
              </h1>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Этап согласования</label>
                <select
                  className="form-select"
                  onChange={selectStageApprove}
                  value={userApprove["status_id"]}
                >
                  <option value="1">Не согласовано</option>
                  <option value="2">На доработке</option>
                  <option value="3">Согласовано</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Комментарий</label>
                <textarea
                  className="form-control"
                  rows={3}
                  onChange={onChangeCommentApprove}
                  value={userApprove["comment"]}
                />
              </div>
              <div className="text-center">{approveMessage}</div>
            </div>
            <div className="modal-footer justify-content-center">
              <button type="button" className="btn" onClick={approveSchedule}>
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleMNG;

function isWeekend(dateString) {
  const day = new Date(dateString).getDay();
  return day === 0 || day === 6;
}

function getFormattedMonthDates(inputDate) {
  const date = new Date(inputDate);

  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return [formatDate(firstDay), formatDate(lastDay)];
}

const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function formatMngDisplayDate(dateString) {
  if (!dateString) return "—";
  const date = new Date(dateString);
  const weekdays = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year} (${weekdays[date.getDay()]})`;
}
